import insert from './insert';
import result from './result';
import verify from './verify';
import options from './options';
import result2 from './result2';
import insert2 from './insert2';
import summary from './summary';


export default {
    insert,
    result,
    verify,
    options,
    result2,
    insert2,
    summary
}